export default "__VITE_ASSET__c20b21ht__"